/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import {
  BilancioConsolidatoDto,
  ValoriAnnoPrecedenteDto,
} from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';
import { Ente } from '@ideapa/app-shared-ente';
import { SoggettoPerConsolidato } from '@ideapa/common-utils';

@Injectable()
export class ValoriAnnoPrecedenteApiClient extends BaseCRUDApiClient<ValoriAnnoPrecedenteDto> {
  baseUrl = this.config.apiEndpoint + '/bilancio-consolidato';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getSoggettiPerConsolidato(ente: Ente) {
    return this.http.post<SoggettoPerConsolidato[]>(
      this.baseUrl + '/partecipate',
      { ente: ente }
    );
  }

  getBCAnnoPrecedente() {
    return this.http.get<BilancioConsolidatoDto>(
      this.baseUrl + '/get-anno-precedente'
    );
  }

  estraiBCAnnoPrecedente() {
    return this.http.get<BilancioConsolidatoDto>(
      this.baseUrl + '/estrai-anno-precedente'
    );
  }

  calcolaBCAnnoPrecedente() {
    return this.http.get<BilancioConsolidatoDto>(
      this.baseUrl + '/calcola-anno-precedente'
    );
  }

  updateRigaBC(idRiga: number, importoAP: number) {
    return this.http.post<BilancioConsolidatoDto>(
      this.baseUrl + '/update-riga-anno-precedente',
      {
        idRiga: idRiga,
        importoAP: importoAP,
      }
    );
  }
}
